import React from 'react';
import {IPresentationMeta} from '../../../../incase-domain/presentation';
import Modal from '../../../../incase-domain/components/modals/directory/Modal';
import ViewerPresentationLinks from './components/ViewerPresentationLinks';

interface CreatePresentationLinksProps {
    open: boolean;
    closeModal: () => void;
    presentation: IPresentationMeta;
    roomId?: string;
    presenterLinkCode?: string;
}

CreatePresentationLinksModals.defaultProps = {
    roomId: '',
};

function CreatePresentationLinksModals(props: CreatePresentationLinksProps): JSX.Element {
    const {open, closeModal, presentation, roomId, presenterLinkCode} = props;

    const handleCloseModal = (): void => {
        closeModal();
    };

    return (
        <Modal
            icon="solar:link-bold"
            isOpen={open}
            onCancel={handleCloseModal}
            onConfirm={handleCloseModal}
            size="fit"
            dataCy="create_links"
        >
            <ViewerPresentationLinks presentation={presentation} open={open} roomId={roomId} presenterLinkCode={presenterLinkCode} />
        </Modal>
    );
}

export default CreatePresentationLinksModals;
